import React from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";

const root = createRoot(document.getElementById("root")!);
root.render(<App />);

// Register service worker for push notifications
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.register("/sw.js").then(
    (reg) => console.log("[SW] Registered:", reg.scope),
    (err) => console.warn("[SW] Registration failed:", err)
  );
}
